export const BANNER_TOASTS = {
  instantAccess: {
    name: 'instantAccess',
    message: 'This is an instant access account.'
  },
  cspCustomer: {
    name: 'cspCustomer',
    message: 'This is a verified account.'
  }
};

export const BANNER_TOAST_MESSAGES_SHOWED = 'BANNER_TOAST_MESSAGES_SHOWED';

export const DELAY_VERIFIED_TOAST_MESSAGE_IN_SECONDS = 5;
